import { AxiosRequestConfig } from "axios"

import { privateFetch, publicFetch } from "../libs/axios"

export const genericUpload = async (body: any, config?: AxiosRequestConfig) =>
  await privateFetch().post<any>(`/api/v1/generic-upload`, body, config)
export const privateUpload = async (templateId: string, body: any, config?: AxiosRequestConfig) =>
  await publicFetch().post<any>(`/api/v1/public/waiver/${templateId}/uploadImage`, body, config)
